import React from "react";
import { Table, From, Input } from "antd";
import { skladDetali } from "../Form/formData";
import { newData } from "../Form/TableData";
import AddModal from "../Modal/index";

function SkladDetali() {
  const columns = [
    {
      title: "#",
      dataIndex: "key",
    },
    {
      title: "Dokument",
      dataIndex: "name",
    },
    {
      title: "Data",
      dataIndex: "data",
    },
    {
      title: "Postavshik",
      dataIndex: "postavshik",
    },
    {
      title: "Sklad",
      dataIndex: "sklad",
    },
    {
      title: "Kommentarii",
      dataIndex: "sklad",
    },
    {
      title: "Vsego",
      dataIndex: "vsego",
    },
  ];

  return (
    <>
      <AddModal
        title={"Поступ.детали"}
        stil={"stil"}
        columnsAll={skladDetali[0].columns}
        form={skladDetali}
        width={850}
        table={newData}
        button={true}
      />
      <div className="mt-2">
        <Table columns={columns} />
      </div>
    </>
  );
}

export default SkladDetali;
